import styled from 'styled-components';
import { rem } from '../../utils/Polished';
import TooltipBase from './TooltipBaseSC';
export default styled(TooltipBase) `
  background-color: ${(props) => props.theme.ColorBackgroundTooltipDialogBase};
  box-shadow: ${(p) => p.theme.SizeShadowTooltipDialog}
    ${(p) => p.theme.ColorShadowTooltipDialog};

  ._ndsTooltip__content {
    padding: ${rem('15px')};
    width: ${(p) => p.theme.SizeWidthTooltipBase};
    background-color: ${(props) => props.theme.ColorBackgroundTooltipDialogBase};
    & > [class*='_ndsPopupTitle']:first-child {
      margin-top: ${rem('-4px')};
    }
  }

  &._ndsTooltip__inverted-bg ._ndsTooltip__content {
    background-color: ${(props) => props.theme.ColorBackgroundTooltipDialogInvertedBg};
  }

  ._ndsTooltip__arrow {
    width: ${(p) => p.theme.SizeWidthTooltipArrowDialogBase};
    height: ${(p) => p.theme.SizeHeightTooltipArrowDialogBase};
    background: ${(p) => p.theme.ColorBackgroundTooltipDialogBase};
    box-shadow: ${(p) => p.theme.SizeShadowTooltipDialog}
      ${(p) => p.theme.ColorShadowTooltipDialog};
  }

  &._ndsTooltip__inverted-bg ._ndsTooltip__arrow {
    background: ${(props) => props.theme.ColorBackgroundTooltipDialogInvertedBg};
  }
`;
//# sourceMappingURL=TooltipDialogSC.js.map